<div #dialogDelete class="modal fade" bsModal #confirmDialog="bs-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left"> {{dialogTitle}}</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" [innerHTML]="dialogContent">
            </div>
            <div class="modal-footer">
                <div class="text-right">
                    <button type="button" class="btn btn-lg btn-danger btn-sm" (click)="delete()">
                        <i class="fa fa-trash"></i> Xóa
                    </button>
                    <button type="button" class="btn btn-lg btn-default ml-2 btn-sm" (click)="hide()">
                        <i class="fa fa-times"></i> Đóng
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>